import Navbar from "../Layout/Navbar";
import Hero from "../Layout/Hero";
import Footer from "../Layout/Footer";


export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Footer marginTop="-80px"/>
    </>
  );
}
